import React from "react";
import "./PageLoader.scss";
import Image from "../../image/Image";
import { AppIcons } from "../../../data/appIcons";

function PageLoader() {
  return (
    <div className="page-loader-background">
      <div className="main-loader-sec">
        <div className="logo_loader">
          <div className="overlaybox" id="progress">
            <Image
              imagePath={AppIcons.AnimationLogoNormalImg}
              altText="Loader Img"
            />
          </div>
          <div className="overlaybox2">
            <Image imagePath={AppIcons.AnimationLogoTpImg} altText="Loader Img" />
          </div>
          <Image imagePath={AppIcons.AnimationLogoTpImg} altText="Loader Img" />
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
